import React, { useState } from "react";
import { withRedux } from "helpers";
import { Input } from "components";
import styled, { css } from "react-emotion";
import WebIcon from "../../../WebIcon";

const qtyInputStyle = css`
  width: 50px;
  font-weight: 500;
  text-align: center;
  -webkit-appearance: none;
  -webkit-border-radius: 0;
  box-sizing: border-box;
  border: 1px solid #999;
  padding: 0.4em 0.7em;
  outline: none;
  display: block;
  min-height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
`;

const qtyWrap = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function QtyInput(props) {
  const {
    cartItem,
    onCartItemChange,
    isInCart,
    index,
    purchaseItemInfo,
    purchaseItemInfo: { maxPurchasesReached, purchasesRemaining, soldOut },
  } = props;

  // console.dir(purchaseItemInfo);

  const updateQty = (tempCartItem, oldQty) => {
    if (isInCart) {
      props.actions.updateProductQty(tempCartItem, oldQty, index);
    } else {
      onCartItemChange(tempCartItem);
    }
  };
  const onChangeHandler = (event) => {
    // console.log("====> updating qty value now");
    const newValue = parseInt(event.target.value);
    if (!isNaN(newValue)) {
      const oldQty = cartItem.quantity;
      const tempCartItem = { ...cartItem, quantity: 1 };
      tempCartItem.quantity = newValue;

      updateQty(tempCartItem, oldQty);
    }
  };

  const decrementQty = () => {
    if (cartItem.quantity - 1 > 0) {
      const oldQty = cartItem.quantity;
      const tempCartItem = { ...cartItem };
      tempCartItem.quantity -= 1;

      updateQty(tempCartItem, oldQty);
    }
  };
  const incrementQty = () => {
    if (
      purchasesRemaining === null ||
      (purchasesRemaining > 0 && cartItem.quantity < purchasesRemaining)
    ) {
      // console.log("incrementing quantity...");
      // console.log(cartItem.quantity);
      const oldQty = cartItem.quantity;
      const tempCartItem = { ...cartItem };
      tempCartItem.quantity += 1;
      // console.log("new qty: " + tempCartItem.quantity);
      updateQty(tempCartItem, oldQty);
    }
  };
  return (
    <div className={qtyWrap}>
      <div onClick={decrementQty} style={{ marginRight: "5px" }}>
        <WebIcon
          iconName={"minus"}
          useColor={true}
          customColor={cartItem.quantity - 1 > 0 ? null : "grey"}
          hover={true}
          size={"12px"}
        />
      </div>

      <input
        className={qtyInputStyle}
        type="text"
        onChange={onChangeHandler}
        value={cartItem.quantity}
        min="1"
        max={purchasesRemaining}
        pattern="\d*"
      />

      <div
        onClick={incrementQty}
        style={{
          marginLeft: "5px",
        }}
      >
        <WebIcon
          iconName={"plus"}
          useColor={true}
          customColor={
            purchasesRemaining === null ||
            (purchasesRemaining > 0 && cartItem.quantity < purchasesRemaining)
              ? null
              : "grey"
          }
          hover={true}
          size={"12px"}
        />
      </div>
    </div>
  );
}

export default withRedux(QtyInput);
